<div [className]="isSearchResult ? 'email-chip is-search-result' : 'email-chip'">
    <div class="chip-avatar">
        <img [src]="recipient.imageUrl" [alt]="recipient.name" *ngIf="recipient.imageUrl">
        <div class="avatar-placeholder" *ngIf="!recipient.imageUrl">
            {{ recipient.name.charAt(0).toUpperCase() }}
        </div>
    </div>
    <div class="chip-info">
        <span class="chip-name" *ngIf="recipient.job">{{ recipient.name }} - {{ recipient.job }}</span>
        <span class="chip-name" *ngIf="!recipient.job">{{ recipient.name }} - {{ recipient.businessGroup }} - {{ recipient.rank }}</span>
    </div>
    <ion-icon *ngIf="removable" name="close-outline" class="chip-remove" (click)="onRemove()"></ion-icon>
</div>
